<template>
  <AcademicCardsChapter
    page-title="国内学术交流"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :sections="sections"
  />
</template>

<script>
import AcademicCardsChapter from '@/components/AcademicCardsChapter.vue';

export default {
  name: 'Lanhuguoneixueshujiaoliu',
  components: {
    AcademicCardsChapter
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      sections: [
        {
          title: '1981—1986 年国内学术交流',
          summary: '从延安《解放日报》研究座谈会到全国好新闻定评会，新闻研究所持续参与国内重要新闻理论与传播学术活动。',
          columns: 2,
          cards: [
            {
              title: '1981 年延安《解放日报》研究座谈会',
              src: require('./assets/html/domestic-1981-yanan.jpg'),
              description: '1981 年 3 月 18 日，新闻研究所与中国记协召开延安《解放日报》研究座谈会，延安《解放日报》原总编辑陆定一主持。'
            },
            {
              title: '1981 年全国第一次新闻研究工作会议',
              src: require('./assets/html/domestic-1981-workshop.jpg'),
              description: '1981 年 12 月 7 日至 12 日，全国第一次新闻研究工作会议召开，围绕新闻理论与研究工作交流经验。'
            },
            {
              title: '1983 年纪念马克思逝世 100 周年讨论会',
              src: require('./assets/html/domestic-1983-marx.jpg'),
              description: '1983 年 3 月，纪念马克思逝世 100 周年新闻学术讨论会举行。'
            },
            {
              title: '1983 年纪念毛泽东诞辰 90 周年讨论会',
              src: require('./assets/html/domestic-1983-mao.jpg'),
              description: '1983 年 12 月，纪念毛泽东诞辰 90 周年全国新闻学术讨论会召开。'
            },
            {
              title: '1983 年专业报研究组成立大会',
              src: require('./assets/html/domestic-1983-professional-paper.jpg'),
              description: '1983 年 5 月，北京新闻学会召开专业报研究组成立大会。'
            },
            {
              title: '1984 年“三 S”研究会筹备会',
              src: require('./assets/html/domestic-1984-sss-prep.jpg'),
              description: '1984 年 9 月 11 日，“中国三 S 研究会”筹备委员会第一次会议举行。'
            },
            {
              title: '1985 年世界新闻新秩序问题研讨会',
              src: require('./assets/html/domestic-1985-world-order.jpg'),
              description: '1985 年 4 月，世界新闻新秩序问题研讨会举行。'
            },
            {
              title: '1984 年中国新闻学会联合会成立大会',
              src: require('./assets/html/domestic-1984-federation.jpg'),
              description: '1984 年 12 月，中国新闻学会联合会成立大会召开。'
            },
            {
              title: '1986 年中国新闻学会联合会第一届年会',
              src: require('./assets/html/domestic-1986-annual-meeting.jpg'),
              description: '1986 年 4 月，中国新闻学会联合会第一届年会举行。'
            },
            {
              title: '1986 年第七届全国好新闻定评会',
              src: require('./assets/html/domestic-1986-good-news.jpg'),
              description: '1986 年 5 月，第七届全国好新闻定评会召开。'
            }
          ]
        },
        {
          title: '2000—2008 年专题研讨与论坛',
          summary: '进入新世纪后，新闻与传播研究所围绕党报研究、文明论坛、传播学高端会议与专栏创刊继续拓展交流平台。',
          columns: 2,
          cards: [
            {
              title: '2005 年《新青年》与当代中国学术研讨会',
              src: require('./assets/html/domestic-2005-new-youth.jpg'),
              description: '2005 年 11 月，《新青年》与当代中国学术研讨会举行。'
            },
            {
              title: '2001 年“党与党报”学术研讨会',
              src: require('./assets/html/domestic-2001-party-newspaper.jpg'),
              description: '2001 年 6 月，“党与党报”学术研讨会召开。'
            },
            {
              title: '2000 年《新中国传媒五十年》出版座谈会',
              src: require('./assets/html/domestic-2000-media50.jpg'),
              description: '2000 年 6 月，《新中国传媒五十年》出版座谈会在京举行。'
            },
            {
              title: '2006 年中国首届文明论坛',
              src: require('./assets/html/domestic-2006-civilization.jpg'),
              description: '2006 年 12 月，中国首届文明论坛召开。'
            },
            {
              title: '2007 年中国传播学高端学术研讨会',
              src: require('./assets/html/domestic-2007-communication.jpg'),
              description: '2007 年 8 月，2007 中国传播学高端学术研讨会举行。'
            },
            {
              title: '2008 年“雪君工作室”专栏创刊研讨会',
              src: require('./assets/html/domestic-2008-xuejun.jpg'),
              description: '2008 年 10 月，“雪君工作室”专栏创刊 5 周年研讨会召开。'
            }
          ]
        },
        {
          title: '2009—2018 年平台建设与新品发布',
          summary: '这一时期的国内交流更强调学术平台建设、名词审定、教材研讨与新品力作发布，形成持续性的学术合作网络。',
          columns: 2,
          cards: [
            {
              title: '2009 年中国经济舆情学术研讨会',
              src: require('./assets/html/domestic-2009-economic-opinion.jpg'),
              description: '2009 年 10 月，“中国经济舆情与《今日观察》学术研讨会”举行。'
            },
            {
              title: '2010 年《中国传播学 30 年》首发式',
              src: require('./assets/html/domestic-2010-communication30.jpg'),
              description: '2010 年 7 月，《中国传播学 30 年》首发式在京举行。'
            },
            {
              title: '2012 年全国新闻记者培训教材编写研讨会',
              src: require('./assets/html/domestic-2012-training.jpg'),
              description: '2012 年 9 月，全国新闻记者培训教材编写研讨会召开。'
            },
            {
              title: '2012 年全球影视与文化软实力实验室揭牌',
              src: require('./assets/html/domestic-2012-softpower.jpg'),
              description: '2012 年 11 月，“全球影视与文化软实力实验室”揭牌仪式暨研讨会举行。'
            },
            {
              title: '2013 年“变革中的新闻与传播”研讨会',
              src: require('./assets/html/domestic-2013-change.jpg'),
              description: '2013 年 10 月，“变革中的新闻与传播：实践探索与理论构建”学术研讨会召开。'
            },
            {
              title: '2013 年名词审定委员会成立',
              src: require('./assets/html/domestic-2013-terms.jpg'),
              description: '2013 年 9 月，新闻学与传播学名词审定委员会成立。'
            },
            {
              title: '2015 年中国大百科全书新闻学卷编委会',
              src: require('./assets/html/domestic-2015-encyclopedia.jpg'),
              description: '2015 年 1 月，《中国大百科全书》第三版新闻学卷编委会第一次会议召开。'
            },
            {
              title: '2016 年新闻传播学新品力作发布会',
              src: require('./assets/html/domestic-2016-new-books.jpg'),
              description: '2016 年 4 月，中国新闻传播学新品力作发布会举行。'
            },
            {
              title: '2018 年中国新闻奖与长江韬奋奖审核工作会',
              src: require('./assets/html/domestic-2018-awards-review.jpg'),
              description: '2018 年 7 月，中国新闻奖、长江韬奋奖审核工作会召开。'
            },
            {
              title: '2018 年青少年蓝皮书发布会',
              src: require('./assets/html/domestic-2018-youth-bluebook.jpg'),
              description: '2018 年 9 月，青少年蓝皮书发布会举行。'
            },
            {
              title: '2018 年互联网大数据与社会治理智库峰会',
              src: require('./assets/html/domestic-2018-nanjing-summit.jpg'),
              description: '2018 年 1 月，互联网大数据与社会治理南京智库峰会召开。'
            },
            {
              title: '2016 年前沿研究与翻译实践平台签约仪式',
              src: require('./assets/html/domestic-2016-translation-platform.jpg'),
              description: '2016 年 1 月，“文化传播前沿研究与翻译实践平台”合作框架协议签订仪式举行。'
            }
          ]
        }
      ]
    };
  }
};
</script>
